import React from 'react';

const RateLimitInfo = ({ attemptsInfo, timeUntilUnblock }) => {
  if (!attemptsInfo) {
    return null;
  }

  const { remaining, isBlocked, hasUsedOnce } = attemptsInfo;

  // Показываем информацию о блокировке после первого использования
  if (hasUsedOnce && !isBlocked && timeUntilUnblock > 0) {
    const minutes = Math.floor(timeUntilUnblock / (1000 * 60));
    const seconds = Math.floor((timeUntilUnblock % (1000 * 60)) / 1000);
    
    return (
      <div className="mt-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
        <div className="flex items-center">
          <svg className="w-5 h-5 text-gray-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-700 font-medium">
              Форма заблокирована
            </p>
            <p className="text-xs text-gray-500 mt-1">
              {minutes > 0 
                ? `Временная блокировка на 3 минуты. Осталось: ${minutes}м ${seconds}с.`
                : seconds > 0
                ? `Временная блокировка на 3 минуты. Осталось: ${seconds}с.`
                : 'Временная блокировка на 3 минуты. Разблокировка через несколько секунд.'
              }
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (remaining >= 5) {
    return null;
  }

  if (isBlocked) {
    return (
      <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
        <div className="flex items-center">
          <svg className="w-5 h-5 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-red-800 font-medium">
              Превышен лимит попыток
            </p>
            <p className="text-xs text-red-600 mt-1">
              Слишком много неудачных попыток. Попробуйте позже.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (remaining <= 2) {
    return (
      <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
        <div className="flex items-center">
          <svg className="w-5 h-5 text-yellow-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-yellow-800 font-medium">
              Осталось попыток: {remaining}
            </p>
            <p className="text-xs text-yellow-600 mt-1">
              Будьте внимательны при вводе номера заказа
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default RateLimitInfo;
